/* eslint-disable max-len */
import cx from 'clsx';
// styles
import { useStyles } from './shared/styles';

const CollapsableOutlined = ({ className, color, onClick }) => {
  const classes = useStyles();
  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      width="16"
      height="17"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M18.4609 0.171875C19.8281 0.171875 20.9609 1.30469 20.9609 2.67188V15.1719C20.9609 16.5781 19.8281 17.6719 18.4609 17.6719H3.46094C2.05469 17.6719 0.960938 16.5781 0.960938 15.1719V2.67188C0.960938 1.30469 2.05469 0.171875 3.46094 0.171875H18.4609ZM9.71094 15.7969H18.4609C18.7734 15.7969 19.0859 15.5234 19.0859 15.1719V2.67188C19.0859 2.35938 18.7734 2.04688 18.4609 2.04688H9.71094V15.7969ZM4.39844 10.1719C3.85156 10.1719 3.46094 10.6016 3.46094 11.1094C3.46094 11.6562 3.85156 12.0469 4.39844 12.0469H6.27344C6.78125 12.0469 7.21094 11.6562 7.21094 11.1094C7.21094 10.6016 6.78125 10.1719 6.27344 10.1719H4.39844ZM4.39844 6.42188C3.85156 6.42188 3.46094 6.85156 3.46094 7.35938C3.46094 7.90625 3.85156 8.29688 4.39844 8.29688H6.27344C6.78125 8.29688 7.21094 7.90625 7.21094 7.35938C7.21094 6.85156 6.78125 6.42188 6.27344 6.42188H4.39844ZM4.39844 2.67188C3.85156 2.67188 3.46094 3.10156 3.46094 3.60938C3.46094 4.15625 3.85156 4.54688 4.39844 4.54688H6.27344C6.78125 4.54688 7.21094 4.15625 7.21094 3.60938C7.21094 3.10156 6.78125 2.67188 6.27344 2.67188H4.39844Z"
        fill={color}
      />
    </svg>
  );
};

export default CollapsableOutlined;
